module.exports = __webpack_public_path__ + "img/915461096.91e5bb7a.jpg";